module.exports = __webpack_public_path__ + "components/star-rating/static/yellow/10-833491e479d2b3b9e63d6207c09e9a7b.svg";